import { BUCKET_ADMIN } from '@/config/environment';

export const PRISMA_COMPANY_ID = `48c8b458-f044-4796-b88f-0ddb23d087a0`;
export const DEFAULT_LIMIT = 20;

export const STORAGE_TYPE = {
  user: `user-photo-upload`,
  company: `company-photo-upload`,
} as const;

export const DEFAULT_VALIDATION_MESSAGE = (fieldName: string) =>
  `Por favor, preencha o campo ${fieldName}`;

export const DEFAULT_STORAGE_URL = (type: keyof typeof STORAGE_TYPE, fileName: string) =>
  `https://storage.googleapis.com/${BUCKET_ADMIN}/${STORAGE_TYPE[type]}/${fileName}`;
